import { faUsers, faPager, faHouse } from "@fortawesome/pro-solid-svg-icons";
import { type SelectOption } from "@revmatics/catalyst";

// Prod fallbacks guard against missing build-time env vars: a misconfigured
// deploy still points at a working app instead of generating "undefined/funnels".
const LAUNCHPAD_URL =
  import.meta.env.VITE_LAUNCHPAD_URL || "https://launchpad.revmatics.ai/";
const CRO_STUDIO_URL =
  import.meta.env.VITE_CRO_API_URL || "https://studio.revmatics.ai";

// CRO routes by class id. With a known class, deep-link to the brand's
// project dashboard; otherwise fall back to the project picker.
const croStudioHref = (croLegacyClassId: number | null | undefined) =>
  croLegacyClassId != null
    ? `${CRO_STUDIO_URL}/funnel/${croLegacyClassId}`
    : `${CRO_STUDIO_URL}/funnels`;

export const getHeaderSelectAppsData = (
  croLegacyClassId: number | null | undefined,
): SelectOption[] => [
  {
    label: "Home",
    icon: faHouse,
    value: "home",
    href: LAUNCHPAD_URL,
    iconType: "default",
  },
  {
    label: "CRO Studio",
    icon: faPager,
    value: "cro_studio",
    href: croStudioHref(croLegacyClassId),
    iconType: "primary",
  },
  {
    label: "Audience Intelligence",
    icon: faUsers,
    value: "audience_intelligence",
    iconType: "primary",
  },
];
